import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink } from "@/components/NavLink";

export const SiteHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/90 backdrop-blur-xl">
      <div className="container-page flex h-16 sm:h-18 md:h-20 items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 sm:h-11 sm:w-11 md:h-12 md:w-12 lg:h-14 lg:w-14 items-center justify-center rounded-full bg-primary/10 shadow-inner hover-lift">
            <img
              alt="Logotipo do Instituto Evangelístico e Social Sabedoria do Alto"
              className="h-7 w-7 sm:h-8 sm:w-8 md:h-10 md:w-10 lg:h-11 lg:w-11 object-contain"
              loading="lazy"
              src="/lovable-uploads/90481106-653d-4b23-a7c3-b5539a1c1b31.png"
            />
          </div>
          <div className="leading-tight">
            <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-primary">IESSA</p>
            <p className="text-xs sm:text-sm font-medium text-foreground">
              Instituto Evangelístico e Social <span className="text-primary">Sabedoria do Alto</span>
            </p>
          </div>
        </div>

        {/* Desktop navigation */}
        <nav className="hidden items-center gap-6 md:flex">
          <HeaderLink to="/" label="Início" />
          <HeaderLink to="/missao" label="Missão" />
          <HeaderLink to="/missoes-caatinga" label="Missões Caatinga" />
          <HeaderLink to="/projeto-ascender" label="Projeto Ascender" />
          <HeaderLink to="/teologia" label="Curso de Teologia" />
          <HeaderLink to="/blog" label="Blog" />
          <HeaderLink to="/sobre" label="Sobre o Instituto" />
          <HeaderLink to="/contato" label="Contato" />
        </nav>


        {/* Mobile menu toggle */}
        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border border-border/70 bg-background/80 p-2 text-foreground shadow-sm md:hidden"
          aria-label={mobileOpen ? "Fechar menu de navegação" : "Abrir menu de navegação"}
          onClick={() => setMobileOpen((prev) => !prev)}
        >
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile navigation panel */}
      {mobileOpen && (
        <div className="border-t border-border/60 bg-background/95 shadow-lg md:hidden">
          <div className="container-page flex flex-col gap-3 py-4">
            <nav className="flex flex-col gap-2">
              <HeaderLink to="/" label="Início" />
              <HeaderLink to="/missao" label="Missão" />
              <HeaderLink to="/missoes-caatinga" label="Missões Caatinga" />
              <HeaderLink to="/projeto-ascender" label="Projeto Ascender" />
              <HeaderLink to="/teologia" label="Curso de Teologia" />
              <HeaderLink to="/blog" label="Blog" />
              <HeaderLink to="/sobre" label="Sobre o Instituto" />
              <HeaderLink to="/contato" label="Contato" />
            </nav>

          </div>
        </div>
      )}
    </header>
  );
};
interface HeaderLinkProps {
  to: string;
  label: string;
}
const HeaderLink = ({
  to,
  label
}: HeaderLinkProps) => {
  return <NavLink to={to} className="nav-link-base" activeClassName="active-nav" aria-label={label}>
      {label}
    </NavLink>;
};
export default SiteHeader;